import React, { useContext } from 'react';
import { CDropdown, CDropdownDivider, CDropdownItem, CDropdownMenu, CDropdownToggle, CImg } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { useHistory } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import emptyAvatar from '../assets/images/empty-avatar.png';
import ConfirmationDialog from '../shared/components/ConfirmationDialog';
import { selectUserProfile } from '../store/selectors/profile.selectors';
import { ProfileContext } from '../shared/contexts/profile.context';
import { selectUserOrganization } from '../store/selectors/store.selectors';
import { RefreshSubscriptionStatus } from '../store/actions/billing.action';
import { UserRoles } from '../shared/models/user';

const ProfileDropdown = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const profile = useSelector(selectUserProfile);
  const org = useSelector(selectUserOrganization);
  const { showProfileDropdown, setUserStartedTour } = useContext(ProfileContext);
  const {
    enableChargebeeModule,
    enableChargebeePreLaunchRegistrationModule
  } = useFlags();

  const [modalIsOpen, setModelIsOpen] = React.useState(false);

  const navigateTo = (path: string) => {
    history.push(path);
  };

  const toggleConfirmationModal = () => {
    setModelIsOpen(!modalIsOpen);
  };

  const startWalkThrough = async () => {
    setUserStartedTour(true);
  }

  const contactUs = event => {
    window.open('mailto:prosupport@glympse.com', '_blank');
    event.preventDefault();
  };

  const handleLogout = () => {
    navigateTo('/logout');
  };

  const handleAccountBillingClick = () => {
    const cbInstance = window.Chargebee.getInstance();
    const cbPortal = cbInstance.createChargebeePortal();
    cbPortal.open({
      subscriptionChanged: (data) => {
        dispatch(new RefreshSubscriptionStatus(data?.subscription?.id, org._id));
      },
    });
  };

  return (
    <>
      <CDropdown
        id="header-dropdown"
        inNav
        className="c-header-nav-items mx-2"
      >
        <CDropdownToggle className="c-header-nav-link" caret={false}>
          <div className="c-avatar">
            <CImg
              src={profile?.avatar?.url || emptyAvatar}
              className="c-avatar-img"
            />
          </div>
        </CDropdownToggle>
        <CDropdownMenu show={showProfileDropdown} id="profile-dropdown" className="pt-0" placement="bottom-end">
          <CDropdownItem
            header
            tag="div"
            color="light"
            className="text-center"
          >
            <strong>Account</strong>
          </CDropdownItem>
          <CDropdownItem onClick={() => navigateTo('/profile')}>
            <CIcon name="cil-user" className="mfe-2" />Profile
          </CDropdownItem>
          {
            !isEmpty(org?.billing_subscription) && profile?.roles.indexOf(UserRoles.Admin) > -1 && (enableChargebeePreLaunchRegistrationModule || enableChargebeeModule) && (
              <CDropdownItem
                onClick={handleAccountBillingClick}
              >
                <CIcon name='cil-money' className='mfe-2' /> Account & Billing
              </CDropdownItem>
            )
          }
          {
            isEmpty(org?.billing_subscription) && profile?.roles.indexOf(UserRoles.Admin) > -1 && enableChargebeePreLaunchRegistrationModule && (
              <CDropdownItem onClick={() => navigateTo('/setup-subscription')}>
                <CIcon name='cil-user' className='mfe-2' />Set up Billing Account
              </CDropdownItem>
            )
          }
          <CDropdownDivider />
          {
            !isEmpty(org?.billing_subscription) && (
              <CDropdownItem
                onClick={startWalkThrough}
              >
                <CIcon name='cil-flag-alt' className='mfe-2' /> Take a Tour
              </CDropdownItem>
            )
          }
          <CDropdownItem onClick={ contactUs }>
            <CIcon name="cil-envelope-closed" className="mfe-2"/>
            Contact Us
          </CDropdownItem>
          <CDropdownDivider />
          <CDropdownItem id="logout-button" onClick={toggleConfirmationModal}>
            <CIcon name="cil-lock-locked" className="mfe-2"/>
            Log Out
          </CDropdownItem>
        </CDropdownMenu>
      </CDropdown>
      <ConfirmationDialog
        state={modalIsOpen}
        onConfirm={handleLogout}
        onCancel={toggleConfirmationModal}
        title="Log out"
        bodyTxt="Are you sure you want to log out?"
        confirmButtonTxt="Log Out"
      />
    </>
  )
}

export default ProfileDropdown;
